module.exports = __webpack_public_path__ + "1a6b922bbce12fd1f5024b64fa0ac453.svg";